<div class="container">
  <form class="payment-form" [formGroup]="createOrderForm">
    <div class="main-co">
      <div class="wrapper">
        <div class="form-container">
          <ng-container *ngIf="!isFixedPrice">
            <p class="label">Choose Amount</p>
            <div class="input-container">
              <mat-select
                [ngClass]="{
                  'out-of-stock':
                    isSelectedPriceOutOfStock &&
                    createOrderForm.get('customPrice').value
                }"
                formControlName="customPrice"
                (openedChange)="customPriceOpened($event)"
                placeholder="Choose Amount"
              >
                <mat-option
                  *ngFor="let item of customPriceSuggestion"
                  [value]="item.value"
                  [ngClass]="{
                    'out-of-stock-option': isSelectedPriceOutOfStock
                  }"
                >
                  {{ item?.label }}
                </mat-option>
                <mat-option *ngIf="priceOptions.allowCustom" value="custom">
                  Custom
                </mat-option>
              </mat-select>
            </div>
            <div *ngIf="openCustomPriceSelector" class="input-container">
              <div class="price-selector-container">
                <button
                  class="selector"
                  (click)="handlePriceSelector(selectorDirections.decrease)"
                >
                  <img src="/assets/images/icons/minus-blue.svg" alt="" />
                </button>
                <input
                  class="custom-price-input"
                  [placeholder]="customPlaceHolder"
                  type="tel"
                  formControlName="userDefinedCustomPrice"
                  autocomplete="off"
                  twoDigitDecimalNumber
                />
                <button
                  class="selector"
                  (click)="handlePriceSelector(selectorDirections.increase)"
                >
                  <img src="/assets/images/icons/plus-blue.svg" alt="" />
                </button>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="isFixedPrice && productVarieties?.length !== 0">
            <p class="label">Choose Amount</p>
            <div class="input-container">
              <mat-select
                formControlName="price"
                [ngClass]="{
                  'out-of-stock':
                    isSelectedPriceOutOfStock &&
                    createOrderForm.get('price').value
                }"
              >
                <mat-option
                  *ngFor="let productPrice of productVarieties; let i = index"
                  [value]="productPrice"
                  [ngClass]="{
                    'out-of-stock-option': priceOptions.priceList[i].outOfStock
                  }"
                >
                  {{ productPrice?.title
                  }}<span *ngIf="productPrice?.title"> - </span
                  >{{ product?.currency_detail?.symbol
                  }}{{ productPrice?.original_min_price | convertPrice }}
                </mat-option>
              </mat-select>
            </div>
          </ng-container>
          <div class="stock-label">
            <ng-container
              *ngIf="
                !!availableSKUs &&
                (createOrderForm.get('customPrice').value ||
                  createOrderForm.get('price').value)
              "
            >
              <ng-container
                *ngIf="
                  !isSelectedPriceOutOfStock &&
                  !(
                    openCustomPriceSelector &&
                    (!createOrderForm.get('userDefinedCustomPrice').value ||
                      createOrderForm.get('userDefinedCustomPrice').invalid)
                  )
                "
              >
                <img src="/assets/images/icons/tick-circle.svg" alt="" />
                <p class="success">In Stock</p>
              </ng-container>

              <ng-container
                *ngIf="
                  isSelectedPriceOutOfStock &&
                  !(
                    openCustomPriceSelector &&
                    ((createOrderForm.get('userDefinedCustomPrice').value &&
                      createOrderForm.get('userDefinedCustomPrice').invalid) ||
                      !createOrderForm.get('userDefinedCustomPrice').value)
                  )
                "
              >
                <img
                  src="/assets/images/icons/out-of-stock.svg"
                  alt="out of stock icon"
                />
                <p>Out Of Stock</p>
              </ng-container>
              <ng-container
                *ngIf="
                  openCustomPriceSelector &&
                  createOrderForm.get('userDefinedCustomPrice').value &&
                  createOrderForm.get('userDefinedCustomPrice').invalid
                "
              >
                <img src="/assets/images/icons/warning-circle.svg" alt="" />
                <p class="error">
                  Amount Must Be Between {{ product?.currency_detail?.symbol
                  }}{{ rangedMinPrice }} and
                  {{ product?.currency_detail?.symbol }}{{ rangedMaxPrice }}
                </p>
              </ng-container>
            </ng-container>
          </div>
          <div
            *ngIf="!isSelectedPriceOutOfStock"
            class="dashed-border-container"
          >
            <div class="item-title">Payable Amount:</div>
            <div class="item-value">
              <div
                class="product-item pay-price"
                *ngIf="customPriceInput || createOrderForm.get('price').value"
              >
                <p class="payable-price">
                  <span
                    >{{ payablePrice?.currency
                    }}{{ payablePrice?.price | convertPrice }}</span
                  >
                  <span
                    class="raw-price"
                    *ngIf="
                      +product.store_product_detail.discount > 0 &&
                      payablePrice?.price
                    "
                  >
                    {{ payablePrice?.currency
                    }}{{ priceBeforeDiscount | convertPrice }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isSelectedPriceOutOfStock" class="footer">
      <ng-container *ngTemplateOutlet="paymentFooter"></ng-container>
    </div>
  </form>
</div>

<ng-template #paymentFooter>
  <div class="footer-container">
    <button
      mat-button
      class="custom-full-button"
      (click)="handlePaymentData(true)"
      [disabled]="
        (!openCustomPriceSelector && isSelectedPriceOutOfStock) ||
        (openCustomPriceSelector &&
          createOrderForm.get('userDefinedCustomPrice').invalid)
      "
    >
      Continue To Buy
    </button>
    <gift-drawer-button
      [outOfStock]="isSelectedPriceOutOfStock"
    ></gift-drawer-button>
  </div>
</ng-template>
